<template>
  <b-carousel
    :model-value="value"
    :autoplay="autoplay"
    :arrow="arrow"
    :icon-pack="iconPack"
    :icon-prev="iconPrev"
    :icon-next="iconNext"
    :indicator="indicator"
    :repeat="repeat"
    ref="carousel"
  >
    <slot />
  </b-carousel>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CarouselView',
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: Boolean,
      default: true
    },
    iconPack: {
      type: String,
      default: 'cls'
    },
    iconPrev: {
      type: String,
      default: 'chevron-left'
    },
    iconNext: {
      type: String,
      default: 'chevron-right'
    },
    indicator: {
      type: Boolean,
      default: true
    },
    repeat: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    prev() {
      this.$refs.carousel.prev();
    },
    next() {
      this.$refs.carousel.next();
    }
  },
  mounted() {
    // TODO: Remove once vue_compact no longer used
    this.prevHandler = () => this.prev();
    this.nextHandler = () => this.next();

    this.$el.querySelector('.has-icons-left')?.addEventListener('click', this.prevHandler);
    this.$el.querySelector('.has-icons-right')?.addEventListener('click', this.nextHandler);
  },

  beforeUnmount() {
    this.$el.querySelector('.has-icons-left')?.removeEventListener('click', this.prevHandler);
    this.$el.querySelector('.has-icons-right')?.removeEventListener('click', this.nextHandler);
  }
};
</script>
